import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const userData = JSON.parse(localStorage.getItem('user'));
      
      // Include token in user object for API calls
      const userWithToken = { ...userData, token };
      setUser(userWithToken);
      
      // Check if user is admin using the secured endpoint
      fetch(`/api/auth/is-admin`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
        .then(res => res.json())
        .then(data => {
          setIsAdmin(data.isAdmin);
          // Update user object with admin status
          const updatedUser = { ...userWithToken, isAdmin: data.isAdmin };
          localStorage.setItem('user', JSON.stringify({ ...userData, isAdmin: data.isAdmin }));
          setUser(updatedUser);
        })
        .catch(err => {
          console.error('Error checking admin status:', err);
          // If token is invalid, logout the user
          if (err.status === 401 || err.status === 403) {
            logout();
          }
        });
    }
    setLoading(false);
    console.log('AuthContext initialized');
  }, []);

  const login = (userData, token) => {
    const userWithToken = { ...userData, token };
    setUser(userWithToken);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    
    // Check if user is admin using the secured endpoint
    fetch(`/api/auth/is-admin`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        setIsAdmin(data.isAdmin);
        // Update user object with admin status
        const updatedUser = { ...userWithToken, isAdmin: data.isAdmin };
        localStorage.setItem('user', JSON.stringify({ ...userData, isAdmin: data.isAdmin }));
        setUser(updatedUser);
      })
      .catch(err => console.error('Error checking admin status:', err));
    
    console.log('User logged in:', userData);
  };

  const logout = () => {
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    console.log('User logged out');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);


